import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const NousRejoindre = () => {
  return (
    <>
      <Helmet>
        <title>Nous rejoindre - ZiExter | Rejoignez l'équipe</title>
        <meta
          name="description"
          content="Rejoignez ZiExter : opportunités en Tunisie et en remote (Madagascar, Turquie, Inde...). Postulez dès aujourd'hui."
        />
        <link rel="canonical" href="https://ziexter.com/nous-rejoindre" />
      </Helmet>

      {/* Hero (centered, decorative icons & subtle effects) */}
      <section className="page-hero relative overflow-hidden">
        {/* background gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-secondary/95 to-primary/95 pointer-events-none" />

        <div className="container-custom relative z-10">
          <div className="min-h-[56vh] flex flex-col items-center justify-center text-center space-y-6 px-4 animate-fade-in-up">
            <div className="inline-flex items-center gap-3 bg-white/10 backdrop-blur-sm rounded-full px-4 py-2">
              <svg className="w-6 h-6 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 14l9-5-9-5-9 5 9 5z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 14l6.16-3.422M12 14L5.84 10.578M12 14v7" />
              </svg>
              <span className="text-sm text-white/90 font-medium">Carrières • Équipes internationales • Formations</span>
            </div>

            <h1 className="font-heading text-4xl md:text-5xl font-bold leading-tight text-white max-w-2xl">
              Nous rejoindre
            </h1>

            <h2 className="text-xl md:text-2xl font-semibold text-white/90 max-w-3xl">
              Et si la prochaine star, c’était vous ?
            </h2>

            <p className="text-base md:text-lg text-white/80 max-w-3xl">
              Chez ZiExter, nos collaborateurs sont au cœur de notre réussite. Un agent heureux = un client satisfait.
              Que vous soyez débutant motivé ou professionnel confirmé, nous offrons une aventure humaine, des opportunités d’évolution et un cadre de travail stimulant.
            </p>

            <div className="flex flex-col sm:flex-row gap-3 mt-2">
              <Link
                to="/contact"
                className="btn btn-accent btn-lg shadow-lg transform hover:-translate-y-1 transition-all"
                aria-label="Postulez dès aujourd'hui"
              >
                Postulez dès aujourd’hui
              </Link>
            
            </div>
          </div>
        </div>

      
      </section>

      {/* Pourquoi rejoindre */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center mb-10">
            <h2 className="section-title">Pourquoi rejoindre ZiExter ?</h2>
            <p className="text-gray-600">Des équipes dédiées, internationales et focalisées sur la qualité.</p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto mb-12">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 2a10 10 0 100 20 10 10 0 000-20zM2 12h20" />
                </svg>
              </div>
              <div>
                <strong className="block mb-1">Rayonnement international</strong>
                <div className="text-gray-600 text-sm">
                  Clients en Tunisie, France, Europe et équipes en remote (Madagascar, Turquie, Inde, Philippines, Maroc).
                </div>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-accent/10 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-accent" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14" />
                </svg>
              </div>
              <div>
                <strong className="block mb-1">Inbound & Outbound</strong>
                <div className="text-gray-600 text-sm">Réception et émission d’appels, support multicanal et back-office, toujours humain et personnalisé.</div>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-secondary/10 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7v4a1 1 0 001 1h3l3 3v-7l3-3h5a1 1 0 011 1v10" />
                </svg>
              </div>
              <div>
                <strong className="block mb-1">Équipes hybrides & dédiées</strong>
                <div className="text-gray-600 text-sm">Bureaux à Ksibet El Mediouni et collaborateurs en remote. Chaque équipe gère seulement 2–3 clients max pour garantir focus et qualité.</div>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <strong className="block mb-1">Évolution & formation</strong>
                <div className="text-gray-600 text-sm">Formations continues, certifications et opportunités concrètes pour devenir superviseur ou formateur.</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Avantages */}
      <section className="section-padding bg-gray-50">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center mb-8">
            <h2 className="section-title">Les avantages à travailler avec nous</h2>
            <p className="text-gray-600">Un cadre motivant, des outils modernes et beaucoup d'attention portée au bien-être.</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto mb-8">
            <div className="card p-6 hover-lift">
              <div className="font-semibold mb-2">Café & thé à volonté</div>
              <div className="text-gray-600 text-sm">Et du thé à la menthe pour les amateurs.</div>
            </div>

            <div className="card p-6 hover-lift">
              <div className="font-semibold mb-2">Snacks & fruits frais</div>
              <div className="text-gray-600 text-sm">Collations saines disponibles chaque jour.</div>
            </div>

            <div className="card p-6 hover-lift">
              <div className="font-semibold mb-2">Salle de sport</div>
              <div className="text-gray-600 text-sm">Pour rester en forme et garder l'énergie.</div>
            </div>

            <div className="card p-6 hover-lift">
              <div className="font-semibold mb-2">Sorties & team building</div>
              <div className="text-gray-600 text-sm">Activités toutes les deux semaines pour renforcer la cohésion.</div>
            </div>

            <div className="card p-6 hover-lift">
              <div className="font-semibold mb-2">Gamification interne</div>
              <div className="text-gray-600 text-sm">Gagnez des points, débloquez cadeaux et récompenses.</div>
            </div>

            <div className="card p-6 hover-lift">
              <div className="font-semibold mb-2">Formations continues</div>
              <div className="text-gray-600 text-sm">Progression professionnelle soutenue par des parcours de montée en compétence.</div>
            </div>

            <div className="card p-6 hover-lift col-span-full">
              <div className="font-semibold mb-2">Application employé</div>
              <div className="text-gray-600 text-sm">Congés, fiches de paie et infos RH accessibles en un clic.</div>
            </div>
          </div>

          <div className="text-center">
            <Link to="/contact" className="btn btn-primary btn-lg">Envie de travailler avec nous ? Postulez maintenant</Link>
          </div>
        </div>
      </section>

      {/* Profils recherchés */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center mb-8">
            <h2 className="section-title">Profils que nous recherchons</h2>
            <p className="text-gray-600">Motivation, sourire et envie d'apprendre : nous valorisons l'attitude autant que l'expérience.</p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto">
            <div className="card p-6 hover-lift">
              <strong> Téléconseillers Inbound/Outbound (FR/AR)</strong>
              <p className="text-gray-600 text-sm mt-2">Bilingues, orientés service client.</p>
            </div>

            <div className="card p-6 hover-lift">
              <strong> Agents back-office</strong>
              <p className="text-gray-600 text-sm mt-2">Soutien administratif et gestion des processus.</p>
            </div>

            <div className="card p-6 hover-lift">
              <strong> Superviseurs & formateurs</strong>
              <p className="text-gray-600 text-sm mt-2">Encadrement, coaching et transmission des bonnes pratiques.</p>
            </div>
          </div>

          <div className="text-center mt-8">
            <p className="text-sm text-gray-600 mb-4">Pas d’expérience ? Pas de problème — la motivation et l’envie d’apprendre comptent plus.</p>
            <Link to="/contact" className="btn btn-accent">Postulez dès maintenant</Link>
          </div>
        </div>
      </section>

      {/* Témoignages collaborateurs */}
      <section className="section-padding bg-gray-50">
        <div className="container-custom">
          <div className="max-w-3xl mx-auto text-center mb-8">
            <h2 className="section-title">Témoignages de nos collaborateurs</h2>
          </div>

          <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
            <div className="card p-6 hover-lift">
              <p className="italic text-gray-700 mb-4">"J’ai rejoint ZiExter sans expérience. Aujourd’hui, je suis superviseur d’une équipe de 15 personnes !"</p>
              <div className="font-semibold">Houda — Superviseure</div>
            </div>

            <div className="card p-6 hover-lift">
              <p className="italic text-gray-700 mb-4">"Je n’ai jamais vu une ambiance pareille. On travaille sérieusement, mais toujours avec le sourire."</p>
              <div className="font-semibold">Sami — Téléconseiller</div>
            </div>

            <div className="card p-6 hover-lift">
              <p className="italic text-gray-700 mb-4">"ZiExter m’a permis d’apprendre, de progresser et surtout de croire en moi."</p>
              <div className="font-semibold">Maroua — Back-office</div>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="section-padding bg-white">
        <div className="container-custom text-center">
          <h3 className="text-2xl font-bold mb-4">Rejoignez l’aventure ZiExter</h3>
          <p className="text-gray-700 mb-6">Envie d’un emploi stable, motivant et plein d’opportunités ? Venez construire votre avenir avec nous.</p>
          <Link to="/contact" className="btn btn-primary btn-lg">Postulez dès maintenant</Link>
        </div>
      </section>
    </>
  );
};

export default NousRejoindre;